import React, { useRef } from 'react'
import { Grid } from '@material-ui/core'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

import useTranslate from '../../../../../../i18n/useTranslate'
import useSignRepresent from './useSignRepresent'
import { ButtonSign } from '../../pageAction'
import Dialog from '../../../../../../control/dialog/dialog'
import MyAccordion from '../../../../../../control/accordion/accordion'
import Checkbox from '../../../../../../control/checkbox/checkbox'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import constSubmittedStep from '../../../../../../constants/submittedStep'

type ErrorsType = {
    chairmanSign?: string
    secretarySign?: string
}
export type SignRepresentREC1ViewType = ReturnType<typeof useSignRepresent>
const SignRepresentREC1View = (props: SignRepresentREC1ViewType) => {
    const {
        onRefDialog,
        configDialog,
        isViewMode,
        initialValues,
        handleDirtyChange,
        onSubmitForm,
        projectData,
        initialMemorandumFile,
        memorandumTopic,
    } = props

    const translate = useTranslate()
    const isFirstTime = useRef<boolean>(true)

    //มีการลงนามไปแล้ว
    const isSignMemoMessage: boolean =
        projectData?.stepID === constSubmittedStep.sign &&
        projectData?.submittedStatusInfo?.value === constSubmittedStatus.complete

    return (
        <Form
            onSubmit={onSubmitForm}
            initialValues={{
                ...initialValues,
                memorandumFile: initialMemorandumFile,
            }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
            validate={(values) => {
                const errors: ErrorsType = {}
                if (!initialValues.secretarySign) {
                    /* case1 ยังไม่มีค่าใดถูกเลือกเลย */
                    if (!values.secretarySign) {
                        // errors.secretarySign = 'กรุณาระบุค่า'
                        errors.secretarySign = translate.get('MESSAGE.M016')
                    }
                }
                return errors
            }}
        >
            {(props) => {
                return (
                    <React.Fragment>
                        <Grid container spacing={2} justify={'flex-end'}>
                            <Grid item xs={12} md={12} lg={12}>
                                <MyAccordion title={translate.get('LABEL.SIGNED_SUBSTITUTION')}>
                                    <Grid item xs={12} md={3} lg={1}>
                                        <Checkbox
                                            name="secretarySign"
                                            // label={translate.get('LABEL.PRESIDENT')}
                                            label={translate.get('LABEL.SECRETARY')}
                                            disabled={isViewMode || initialValues.secretarySign}
                                            onChangeValue={() => {
                                                isFirstTime.current = false
                                            }}
                                            required
                                        />
                                    </Grid>
                                </MyAccordion>
                            </Grid>

                            {isSignMemoMessage && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <UploadDoc
                                        name={'memorandumFile'}
                                        initialData={initialMemorandumFile}
                                        documentTitleList={memorandumTopic}
                                        title={translate.get('LABEL.MEMO_MESSAGE_DOC_SIGN')}
                                        isViewMode={true}
                                        disabledBtn={true}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {!isViewMode && (
                            <ButtonSign
                                onClickSave={() => {
                                    props.form.change('saveType', 'SAVE')
                                    props.handleSubmit()
                                }}
                            />
                        )}
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}
export type SignRepresentREC1Type = { callbackSaveComplete?: (status: number, isDraft: boolean) => void }
const SignRepresentREC1 = (props: SignRepresentREC1Type) => {
    const signRepresent = useSignRepresent(props)
    return <SignRepresentREC1View {...signRepresent} />
}

export default SignRepresentREC1
